export default {
  lockers: [],
  locker: {}
}